import{purryOrderRules as e}from"./purryOrderRules-CfRtTEyM.js";function t(...t){return e(n,t)}const n=(e,t)=>[...e].sort(t);export{t as sortBy};
//# sourceMappingURL=sortBy-xF7JVODx.js.map